import { CLASS_BOARD_DETAILS } from 'app/view/react_components/aside_panel/boardDetails/constants';
import * as React from 'react';
import './_Template.scss'
import { ITemplateProps } from './types';
import { TEMPLATE_BUTTON, TEMPLATE_LINK, TEMPLATE_TEXT, TEMPLATE_TEXT_LINK } from './constants';
import { Button } from 'kui';

export function Template ({
    isDisallow,
    isShow,
    onClick,
}: ITemplateProps) {
    if (!isShow) return null;

    const className = CLASS_BOARD_DETAILS + '-template';

    return (
        <div className={className}>
            <div className={className + '__text'}>
                {TEMPLATE_TEXT}
                {' '}
                <a
                    href={TEMPLATE_LINK}
                    target="_blank"
                >
                    {TEMPLATE_TEXT_LINK}
                </a>
            </div>
            <Button onClick={onClick} disabled={isDisallow}>
                {TEMPLATE_BUTTON}
            </Button>
        </div>
    );
}
